module.exports = __webpack_public_path__ + "static/family-planning-0804983970fea8297090819f6f6dee85.png";